import React from 'react';
import { Award, Rocket } from 'lucide-react';
import { useGame } from '../contexts/GameContext';

const WordChain = () => {
  const { wordChain } = useGame();
  
  if (wordChain.length === 0) {
    return null;
  }
  
  return (
    <div className="mb-4 overflow-x-auto">
      <h3 className="text-lg font-medium mb-2 uyghur-text">سۆز زەنجىرى:</h3>
      <div className="flex flex-wrap gap-2 p-2">
        {wordChain.map((item, index) => {
          // Get the last letter of the word for highlighting
          const lastLetterIndex = item.word.length - 1;
          const lastLetter = item.word[lastLetterIndex];
          
          // Special styling for the last word in the chain
          const isLastWord = index === wordChain.length - 1;
          
          return (
            <div 
              key={index}
              className={`px-3 py-2 rounded-lg text-sm flex items-center transition-all ${
                isLastWord ? 'scale-in' : ''
              } ${
                item.player === 'player' 
                  ? 'bg-emerald-100 text-emerald-800' 
                  : 'bg-blue-100 text-blue-800'
              }`}
            >
              {item.player === 'player' ? (
                <Award size={14} className="mr-1" />
              ) : (
                <Rocket size={14} className="mr-1" />
              )}
              <span className="uyghur-text">
                {item.word.substring(0, lastLetterIndex)}
                <span className="font-bold">
                  {lastLetter}
                </span>
                {index < wordChain.length - 1 && (
                  <span className="inline-block mx-1">→</span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WordChain;